import { isAuthenticated } from '@connected/api-client/lib/authentication';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth')({
    component: RouteComponent,
    beforeLoad: async ({ location }) => {
        if (isAuthenticated()) {
            console.warn('User is authenticated, redirecting to home page.');
            return;
        }

        console.warn('User is not authenticated, redirecting to login page.');

        throw redirect({
            to: '/login',
            search: {
                redirectPath: location.href,
            },
        });
    },
    wrapInSuspense: true,
    loader: async () => (
        <p>Loading...</p>
    ),
});

function RouteComponent() {
    return <Outlet />;
}
